export default "__VITE_ASSET__C$R10p5Q__"